// extracted by mini-css-extract-plugin
export default {"search__title":"Input_search__title__l9TCE","search__field":"Input_search__field__XAWbj","search__icon":"Input_search__icon__8vGrN"};